import { withDependencies } from '@wix/thunderbolt-ioc'
import type { ServiceProvider } from '@wix/thunderbolt-symbols'
import type { ServiceFactoryOpts } from '@wix/services-manager/types'
import {
	FedopsLoggerDefinition as definition,
	FedopsLoggerService as impl,
	IFedopsLoggerDefinition,
	IFedopsLoggerService,
	IFedopsLoggerServiceConfig,
} from '@wix/viewer-service-fedops-logger'

export const fedopsLoggerService = withDependencies(
	[],
	(): ServiceProvider<
		IFedopsLoggerDefinition,
		(opts: ServiceFactoryOpts<IFedopsLoggerServiceConfig>) => IFedopsLoggerService
	> => {
		return {
			definition,
			impl,
			config: {},
			platformConfig: {},
		}
	}
)
